<template>
  <section class="stepPage">
    <infoUpDown :bread="'Quiz'">
      <el-form ref="ref_submitForm" class="step-main-form step5Form" :model="submitForm" :rules="submitFormRules" label-width="170px">
        <el-form-item :label="'已选中' + checkedTypeParams.checkedType[0].name" :prop="checkedTypeParams.checkedType.length === 1 ? 'checkedWords' : ''">
          <step5Tags v-model="submitForm.checkedWords" :tags-options="wordOptions" />
        </el-form-item>
        <el-form-item v-if="checkedTypeParams.checkedType.length === 2" label="已选中字母" prop="checkedWords2">
          <step5Tags v-model="submitForm.checkedWords2" :tags-options="wordOptions2" />
        </el-form-item>
        <el-button type="primary" size="small" @click="addGamePopupClick">添加内容</el-button>
      </el-form>
      <div class="quiz-container">
        <div v-for="(item, index) in quizTypeObject[courseData.curriculumType].list" :key="index" class="game-bar">
          <h3 class="tit">{{ item.tit }}</h3>
          <div class="cont">
            <img :src="item.gameImg">
            <div class="bottom">
              <el-checkbox v-model="quizTypeObject[courseData.curriculumType].checkedArr" :label="item.type" :disabled="!quizTypeObject[courseData.curriculumType].hasConfigArr.includes(item.type)">使用游戏</el-checkbox>
              <span v-if="!quizTypeObject[courseData.curriculumType].hasConfigArr.includes(item.type)" class="b-tip">
                <SvgIcon icon-class="warn" size="14px" />
                游戏未配置</span>
              <el-button type="success" size="mini" :disabled="isDisabledGameOptions(item)" @click="setGameOptions(item)">配置内容</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-right-bar">
        <el-button v-if="$store.state.courseStep.stepActive > 0" type="info" @click="preStep">上一步</el-button>
      </div>
    </infoUpDown>

    <popup v-show="isShowGamePopup" :bread="'教材管理,课程管理,添加课程,' + currentCourseName + ',' + stepOptions[stepActive].dicName + ',添加内容'" @onBack="addGamePopupBack">
      <template slot="button">
        <el-button type="success" @click="confirmAdd">确认添加</el-button>
      </template>
      <section class="stepPage">
        <infoUpDown :bread="'添加内容'">
          <el-form ref="ref_step_form" class="step-main-form" :model="stepForm" :rules="rules" label-width="170px">
            <el-form-item :label="'已选中' + checkedTypeParams.checkedType[0].name" :prop="checkedTypeParams.checkedType.length === 1 ? 'checkedWords' : ''">
              <checkedTags v-model="stepForm.checkedWords" :tags-options="wordOptions" />
            </el-form-item>
            <el-form-item v-if="checkedTypeParams.checkedType.length === 2" label="已选中字母" prop="checkedWords2">
              <checkedTags v-model="stepForm.checkedWords2" :tags-options="wordOptions2" />
            </el-form-item>
          </el-form>
          <div class="checked-container">
            <el-tabs v-model="activeTabsName" class="step-el-tabs" type="card">
              <el-tab-pane :label="checkedTypeParams.checkedType[0].name" name="0">
                <wordCheckbox v-if="checkedTypeParams.checkedType[0].basicMeans === 'WORD_MEANS'" :checked-word-ids.sync="stepForm.checkedWords" :word-list="wordOptions" />

                <!-- 高频词，自然拼读，句型组 -->
                <sentenceGroupCheckbox v-else :checked-sentence-group-ids.sync="stepForm.checkedWords" :group-list="wordOptions" :group-type="checkedTypeParams.checkedType[0]" />
              </el-tab-pane>
              <el-tab-pane v-if="checkedTypeParams.checkedType.length === 2" label="字母" name="1">
                <wordCheckbox :checked-word-ids.sync="stepForm.checkedWords2" :word-list="wordOptions2" />
              </el-tab-pane>
            </el-tabs>
            <singleWordDetail :active-tabs-name="activeTabsName" />
          </div>
        </infoUpDown>
      </section>
    </popup>

    <popup v-show="isShowInterference" :bread="'教材管理,课程管理,添加课程,' + currentCourseName + ',' + stepOptions[stepActive].dicName + ',配置内容'" @onBack="setGamePopupBack">
      <template slot="button">
        <el-button type="success" @click="saveGameOptions">确认配置</el-button>
      </template>
      <section class="interferenceStepPage">
        <infoUpDown :bread="'配置信息'">
          <!-- 配置游戏选项（干扰项） 动态组件 -->
          <component :is="componentId" ref="ref_game" :key="timestampSetGame" :timestamp="timestampSetGame" :game-list="gameList" :interference-list="interferenceList" :interference-list2="interferenceList2" :current-quiz-type="currentQuizType" @finishSave="finishSaveConfig" />
        </infoUpDown>
      </section>
    </popup>

  </section>
</template>
<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import step5Tags from '../components/step5Tags.vue'
import checkedTags from '../components/checkedTags.vue'
import wordCheckbox from '../components/wordCheckbox.vue'
import sentenceGroupCheckbox from '../components/sentenceGroupCheckbox.vue'
import singleWordDetail from '../components/singleWordDetail.vue'
import { setGame1, setGame2, setGame3, setGame4, setGame5, setGame6, setGame7, setGame8, setGame9, setGame10, setGame11 } from './gamesPopup/index.js'
// import { getDictoryInfoByCode } from '@/api/api_common.js'
import { addStageCurriculumConf, getStepData } from '@api/courseManagement/api_courseManagement'
import { getQuizConfState, getConfData, getQuizConfInterferes, saveQuiz, saveSentenceGroupConf } from '@api/courseManagement/api_quiz'
export default {
  components: {
    step5Tags,
    checkedTags,
    wordCheckbox,
    sentenceGroupCheckbox,
    singleWordDetail,
    setGame1,
    setGame2,
    setGame3,
    setGame4,
    setGame5,
    setGame6,
    setGame7,
    setGame8,
    setGame9,
    setGame10,
    setGame11
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    },
    currentCourseName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checkedArr: [],
      activeTabsName: '0',
      currentVoiceUrl: '',
      submitForm: {
        checkedWords: [],
        checkedWords2: [],
        checkedSentence: []
      },
      stepForm: {
        checkedWords: [],
        checkedWords2: [],
        checkedSentence: []
      },
      rules: {
        checkedWords: [{ type: 'array', required: true, message: '请选择', trigger: 'change' }],
        checkedSentence: [{ type: 'array', required: true, message: '请选择', trigger: 'change' }]
      },
      submitFormRules: {
        checkedWords: [{ type: 'array', required: true, message: '请选择', trigger: 'change' }],
        checkedSentence: [{ type: 'array', required: true, message: '请选择', trigger: 'change' }]
      },

      quizTypeObject: {
        // 单词
        WORDS: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听录音选图片', type: '1001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '图文连线', type: '1002', componentId: 'setGame6', gameImg: require('@assets/images/game2.png') },
            { tit: '看图说话', type: '1003', componentId: 'setGame2', gameImg: require('@assets/images/game15.png') },
            { tit: '听录音判断图片正误', type: '1004', componentId: 'setGame3', gameImg: require('@assets/images/game9.png') },

            { tit: '听录音选图片升级版', type: '1005', componentId: 'setGame6', gameImg: require('@assets/images/game11.png') },
            { tit: '记忆力测试', type: '1006', componentId: 'setGame6', gameImg: require('@assets/images/game13.png') },
            { tit: '听录音跟读', type: '1007', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        },
        // 高频词
        SIGHTWORDS: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听录音选图片', type: '2001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听录音选词成句', type: '2002', componentId: 'setGame8', gameImg: require('@assets/images/game6.png') },
            { tit: '看图说话', type: '2003', componentId: 'setGame2', gameImg: require('@assets/images/game15.png') },
            { tit: '听录音跟读', type: '2004', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        },

        // 阅读
        READING: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听句子选图片', type: '3001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听句子造句', type: '3002', componentId: 'setGame4', gameImg: require('@assets/images/game8.png') },
            { tit: '听句子判断正误', type: '3003', componentId: 'setGame3', gameImg: require('@assets/images/game9.png') },
            { tit: '听录音跟读', type: '3004', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        },

        // 自然拼读
        PHONICS: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听录音选图片', type: '4001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听字母发音选单词', type: '4002', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听录音选字母组词', type: '4003', componentId: 'setGame1', gameImg: require('@assets/images/game7.png') },
            { tit: '看图说话', type: '4004', componentId: 'setGame2', gameImg: require('@assets/images/game15.png') },
            // 新加游戏
            { tit: '听录音大小写字母配对', type: '4005', componentId: 'setGame9', gameImg: require('@assets/images/game14.png') },
            { tit: '听录音选字母成句', type: '4006', componentId: 'setGame10', gameImg: require('@assets/images/game6.png') },
            { tit: '听录音判断图片正误', type: '4007', componentId: 'setGame3', gameImg: require('@assets/images/game9.png') },
            { tit: '听录音判断字母大小写正误', type: '4008', componentId: 'setGame3', gameImg: require('@assets/images/game12.png') },
            { tit: '听录音跟读', type: '4009', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        },

        // 句型
        SENTENCE: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听句子选图片', type: '5001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听句子造句(小火车)', type: '5002', componentId: 'setGame4', gameImg: require('@assets/images/game8.png') },
            { tit: '听句子判断正误', type: '5003', componentId: 'setGame3', gameImg: require('@assets/images/game9.png') },
            { tit: '选单词成句', type: '5004', componentId: 'setGame5', gameImg: require('@assets/images/game6.png') },
            { tit: '选词成句', type: '5006', componentId: 'setGame11', gameImg: require('@assets/images/game8.png') },
            { tit: '听录音跟读', type: '5005', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        },

        // 复习课
        // 单词 复习课
        REVIEWWORDS: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听录音选图片', type: '1001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '图文连线', type: '1002', componentId: 'setGame6', gameImg: require('@assets/images/game2.png') },
            { tit: '看图说话', type: '1003', componentId: 'setGame2', gameImg: require('@assets/images/game15.png') },
            { tit: '听录音判断图片正误', type: '1004', componentId: 'setGame3', gameImg: require('@assets/images/game9.png') },

            { tit: '听录音选图片升级版', type: '1005', componentId: 'setGame6', gameImg: require('@assets/images/game11.png') },
            { tit: '记忆力测试', type: '1006', componentId: 'setGame6', gameImg: require('@assets/images/game13.png') },
            { tit: '听录音跟读', type: '1007', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        },
        // 高频词 复习课
        REVIEWSIGHTWORDS: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听录音选图片', type: '2001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听录音选词成句', type: '2002', componentId: 'setGame8', gameImg: require('@assets/images/game6.png') },
            { tit: '看图说话', type: '2003', componentId: 'setGame2', gameImg: require('@assets/images/game15.png') },
            { tit: '听录音跟读', type: '2004', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        },

        // 阅读 复习课
        REVIEWREADING: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听句子选图片', type: '3001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听句子造句', type: '3002', componentId: 'setGame4', gameImg: require('@assets/images/game8.png') },
            { tit: '听句子判断正误', type: '3003', componentId: 'setGame3', gameImg: require('@assets/images/game9.png') },
            { tit: '听录音跟读', type: '3004', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        },

        // 自然拼读 复习课
        REVIEWPHONICS: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听录音选图片', type: '4001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听字母发音选单词', type: '4002', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听录音选字母组词', type: '4003', componentId: 'setGame1', gameImg: require('@assets/images/game7.png') },
            { tit: '看图说话', type: '4004', componentId: 'setGame2', gameImg: require('@assets/images/game15.png') },
            // 新加游戏
            { tit: '听录音大小写字母配对', type: '4005', componentId: 'setGame9', gameImg: require('@assets/images/game14.png') },
            { tit: '听录音选字母成句', type: '4006', componentId: 'setGame10', gameImg: require('@assets/images/game6.png') },
            { tit: '听录音判断图片正误', type: '4007', componentId: 'setGame3', gameImg: require('@assets/images/game9.png') },
            { tit: '听录音判断字母大小写正误', type: '4008', componentId: 'setGame3', gameImg: require('@assets/images/game12.png') },
            { tit: '听录音跟读', type: '4009', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        },

        // 句型 复习课
        REVIEWSENTENCE: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听句子选图片', type: '5001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听句子造句(小火车)', type: '5002', componentId: 'setGame4', gameImg: require('@assets/images/game8.png') },
            { tit: '听句子判断正误', type: '5003', componentId: 'setGame3', gameImg: require('@assets/images/game9.png') },
            { tit: '选单词成句', type: '5004', componentId: 'setGame5', gameImg: require('@assets/images/game6.png') },
            { tit: '选词成句', type: '5006', componentId: 'setGame11', gameImg: require('@assets/images/game8.png') },
            { tit: '听录音跟读', type: '5005', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        },

        // 测验课
        // 单词 测验课
        TESTWORDS: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听录音选图片', type: '1001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '图文连线', type: '1002', componentId: 'setGame6', gameImg: require('@assets/images/game2.png') },
            { tit: '看图说话', type: '1003', componentId: 'setGame2', gameImg: require('@assets/images/game15.png') },
            { tit: '听录音判断图片正误', type: '1004', componentId: 'setGame3', gameImg: require('@assets/images/game9.png') },

            { tit: '听录音选图片升级版', type: '1005', componentId: 'setGame6', gameImg: require('@assets/images/game11.png') },
            { tit: '记忆力测试', type: '1006', componentId: 'setGame6', gameImg: require('@assets/images/game13.png') },
            { tit: '听录音跟读', type: '1007', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        },
        // 高频词 测验课
        TESTSIGHTWORDS: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听录音选图片', type: '2001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听录音选词成句', type: '2002', componentId: 'setGame8', gameImg: require('@assets/images/game6.png') },
            { tit: '看图说话', type: '2003', componentId: 'setGame2', gameImg: require('@assets/images/game15.png') },
            { tit: '听录音跟读', type: '2004', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        },

        // 阅读 测验课
        TESTREADING: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听句子选图片', type: '3001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听句子造句', type: '3002', componentId: 'setGame4', gameImg: require('@assets/images/game8.png') },
            { tit: '听句子判断正误', type: '3003', componentId: 'setGame3', gameImg: require('@assets/images/game9.png') },
            { tit: '听录音跟读', type: '3004', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        },

        // 自然拼读 测验课
        TESTPHONICS: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听录音选图片', type: '4001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听字母发音选单词', type: '4002', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听录音选字母组词', type: '4003', componentId: 'setGame1', gameImg: require('@assets/images/game7.png') },
            { tit: '看图说话', type: '4004', componentId: 'setGame2', gameImg: require('@assets/images/game15.png') },
            // 新加游戏
            { tit: '听录音大小写字母配对', type: '4005', componentId: 'setGame9', gameImg: require('@assets/images/game14.png') },
            { tit: '听录音选字母成句', type: '4006', componentId: 'setGame10', gameImg: require('@assets/images/game6.png') },
            { tit: '听录音判断图片正误', type: '4007', componentId: 'setGame3', gameImg: require('@assets/images/game9.png') },
            { tit: '听录音判断字母大小写正误', type: '4008', componentId: 'setGame3', gameImg: require('@assets/images/game12.png') },
            { tit: '听录音跟读', type: '4009', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        },

        // 句型 测验课
        TESTSENTENCE: {
          checkedArr: [],
          hasConfigArr: [],
          list: [
            { tit: '听句子选图片', type: '5001', componentId: 'setGame1', gameImg: require('@assets/images/game1.png') },
            { tit: '听句子造句(小火车)', type: '5002', componentId: 'setGame4', gameImg: require('@assets/images/game8.png') },
            { tit: '听句子判断正误', type: '5003', componentId: 'setGame3', gameImg: require('@assets/images/game9.png') },
            { tit: '选单词成句', type: '5004', componentId: 'setGame5', gameImg: require('@assets/images/game6.png') },
            { tit: '选词成句', type: '5006', componentId: 'setGame11', gameImg: require('@assets/images/game8.png') },
            { tit: '听录音跟读', type: '5005', componentId: 'setGame7', gameImg: require('@assets/images/game10.png') }
          ]
        }

      },

      isShowGamePopup: false,
      isShowInterference: false,
      componentId: 'setGame1',
      currentQuizType: '',

      wordOptions: [],
      wordOptions2: [],
      quizTypeList: [],
      // 当前步骤 已经配置过的游戏
      hasConfigArr: [],
      timestampSetGame: 0,
      gameList: [],
      // 干扰项 下拉框选项
      interferenceList: [],
      interferenceList2: []

      // isShowCheckOneSentence: false,
      // checkOneSentenceForm: {
      //   dataList: [
      //     {
      //       url: require('@assets/images/game2.png'),
      //       sentence: '',
      //       sentenceList: ''
      //     }
      //   ]
      // }

    }
  },
  computed: {
    ...mapState('courseStep', ['courseData', 'stepOptions', 'stepActive', 'courseStepOptions']),
    // 当前 已选中类型 传参类型
    checkedTypeParams () {
      return this.courseStepOptions[this.courseData.curriculumType][this.stepOptions[this.stepActive].dicCode]
    },
    isDisabledGameOptions () {
      return function(item) {
        if (this.checkedTypeParams.checkedType[0].basicMeans === 'NATURAL_SPELLING_MEANS' && this.submitForm.checkedWords2.length > 0) {
          if (['4002', '4003', '4004'].includes(item.type)) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    }
  },
  watch: {
    timestamp: function (val) {
      this.checkedTypeParams.checkedType.forEach((item, index) => {
        this.$store.dispatch('courseStep/getCurriculumType', item).then(res => {
          if (index === 0) {
            this.wordOptions = res
          } else {
            this.wordOptions2 = res
          }
        })
      })

      // 单词 调用一次
      if (this.checkedTypeParams.checkedType[0].basicMeans === 'WORD_MEANS') {
        this.getInterferenceList('5')
      } else if (this.checkedTypeParams.checkedType[0].basicMeans === 'SENTENCE_PATTERN_GROUP_MEANS') { // 句型组 调用一次
        this.getInterferenceList('8')
      } else if (this.checkedTypeParams.checkedType[0].basicMeans === 'HIGH_FREQUENCY_MEANS') { // 高频词 调用一次
        this.getInterferenceList('1')
      }
      this.getQuizConfState()
      this.getStepData()
    }
  },
  created() {

  },
  methods: {
    getStepData () {
      const params = {
        dataTypeList: this.checkedTypeParams.checkedType,
        stageType: this.stepOptions[this.stepActive].dicCode,
        teachingCurriculumId: this.courseData.teachingCurriculumId
        // terminalType: this.courseData.terminalType
      }
      getStepData(params).then(res => {
        // res 有值，表明之前已经保存过 该步骤
        if (res) {
          if (this.checkedTypeParams.checkedType.length === 1) {
            this.submitForm.checkedWords = res.firstIds
          } else {
            this.submitForm.checkedWords = res.firstIds || []
            this.submitForm.checkedWords2 = res.twoIds || []
          }

          // 自然拼读模块两个 tab项，需要根据已选中的选项，来判断调用哪个当干扰项
          if (this.checkedTypeParams.checkedType[0].basicMeans === 'NATURAL_SPELLING_MEANS') {
            if (this.submitForm.checkedWords.length > 0) {
              this.getInterferenceList('3')
              this.getInterferenceList('4')
            } else if (this.submitForm.checkedWords2.length > 0) {
              this.getInterferenceList('9')
            }
          }
        }
      })
    },
    // 查询当前页面 游戏勾选状态
    getQuizConfState() {
      getQuizConfState({ curriculumId: this.courseData.teachingCurriculumId }).then(res => {
        this.quizTypeObject[this.courseData.curriculumType].checkedArr = []
        console.log("游戏状态：",res)
        res.forEach(item => {
          this.quizTypeList.push(item.quizType)
          if (item.isOpen === '1') {
            this.quizTypeObject[this.courseData.curriculumType].checkedArr.push(item.quizType)
          }
          // 第一次进入 step5时 存储当前游戏配置状态
          if (item.isConf === '1') {
            this.quizTypeObject[this.courseData.curriculumType].hasConfigArr.push(item.quizType)
          }
        })
      })
    },

    // 查询当前页面 游戏配置状态
    getQuizConfState2() {
      getQuizConfState({ curriculumId: this.courseData.teachingCurriculumId }).then(res => {
        this.quizTypeObject[this.courseData.curriculumType].hasConfigArr = []
        res.forEach(item => {
          if (item.isConf === '1') {
            this.quizTypeObject[this.courseData.curriculumType].hasConfigArr.push(item.quizType)
          }
        })
      })
    },

    // 查询游戏配置项 单词/ 句型选项
    getConfData(item) {
      const params = {
        curriculumId: this.courseData.teachingCurriculumId,
        curriculumType: this.courseData.curriculumType,
        quizType: item.type
      }
      getConfData(params).then(res => {
        this.gameList = res
      })
    },
    // 查询游戏配置项 干扰项
    getInterferenceList(meansType) {
      const params = {
        curriculumId: this.courseData.teachingCurriculumId,
        curriculumType: this.courseData.curriculumType,
        meansType
      }
      getQuizConfInterferes(params).then(res => {
        // 自然拼读 和 高频词模块 会有两个干扰项 数据源
        if (meansType === '4') {
          // 自然拼读 的句型 放到第二个干扰项选项
          this.interferenceList2 = res
        } else {
          this.interferenceList = res
        }
      })
    },

    preStep() {
      this.$emit('preStep')
    },

    setGameOptions(item) {
      this.$refs.ref_submitForm.validate(valid => {
        if (!valid) { return false }
        if (this.checkedTypeParams.checkedType[0].basicMeans === 'NATURAL_SPELLING_MEANS') {
          if (this.submitForm.checkedWords.length === 0 && this.submitForm.checkedWords2.length === 0) {
            this.$message.error('请添加游戏内容')
            return false
          }
        }

        this.currentQuizType = item.type
        this.componentId = item.componentId
        this.getConfData(item)

        // this.getInterferenceList('1')
        this.isShowInterference = true
      })
    },
    addGamePopupClick() {
      this.isShowGamePopup = true
      this.stepForm.checkedWords = _.cloneDeep(this.submitForm.checkedWords)
      if (this.checkedTypeParams.checkedType[0].basicMeans === 'NATURAL_SPELLING_MEANS') {
        this.stepForm.checkedWords2 = _.cloneDeep(this.submitForm.checkedWords2)
      }
    },
    addGamePopupBack() {
      this.isShowGamePopup = false
      this.getStepData()
    },
    // 确认已选中 内容
    confirmAdd() {
      this.$refs.ref_step_form.validate(valid => {
        if (!valid) { return false }
        // 自然拼读模块 两者只能选其一
        if (this.checkedTypeParams.checkedType[0].basicMeans === 'NATURAL_SPELLING_MEANS') {
          if (this.stepForm.checkedWords.length > 0 && this.stepForm.checkedWords2.length > 0) {
            this.$message.error('只能选择一种素材作为游戏添加内容')
            return false
          }
        }
        if (this.checkedTypeParams.checkedType[0].basicMeans === 'NATURAL_SPELLING_MEANS') {
          if (this.stepForm.checkedWords.length === 0 && this.stepForm.checkedWords2.length === 0) {
            this.$message.error('请至少选择一种素材作为游戏添加内容')
            return false
          }
        }
        // 如果再次添加，没有更改任何内容，不调用保存接口，直接关闭弹窗
        // 自然拼读模块比较两个 选中项
        if (this.checkedTypeParams.checkedType[0].basicMeans === 'NATURAL_SPELLING_MEANS') {
          if (JSON.stringify(this.stepForm.checkedWords) === JSON.stringify(this.submitForm.checkedWords) && JSON.stringify(this.stepForm.checkedWords2) === JSON.stringify(this.submitForm.checkedWords2)) {
            this.isShowGamePopup = false
            this.getStepData()
            return false
          }
        } else { // 其他游戏模块 比较一个选中项
          if (JSON.stringify(this.stepForm.checkedWords) === JSON.stringify(this.submitForm.checkedWords)) {
            this.isShowGamePopup = false
            this.getStepData()
            return false
          }
        }

        const params = {
          curriculumType: this.courseData.curriculumType,
          teachingCurriculumId: this.courseData.teachingCurriculumId,
          stageType: this.stepOptions[this.stepActive].dicCode

          // wordMeansIds: this.stepForm.checkedWords.toString()
        }
        if (this.checkedTypeParams.checkedType[0].basicMeans === 'WORD_MEANS') {
          params.wordMeansIds = this.stepForm.checkedWords.toString()
        } else if (this.checkedTypeParams.checkedType[0].basicMeans === 'HIGH_FREQUENCY_MEANS') {
          params.highFrequencyIds = this.stepForm.checkedWords.toString()
        } else if (this.checkedTypeParams.checkedType[0].basicMeans === 'NATURAL_SPELLING_MEANS') {
          // 自然拼读模块 两个选项
          params.naturalSpellingIds = this.stepForm.checkedWords.toString()
          params.letterIds = this.stepForm.checkedWords2.toString()
        } else if (this.checkedTypeParams.checkedType[0].basicMeans === 'SENTENCE_PATTERN_GROUP_MEANS') {
          params.sentencePatternGroupIds = this.stepForm.checkedWords.toString()
        }

        addStageCurriculumConf(params).then(res => {
          this.$message.success('操作成功')
          this.isShowGamePopup = false
          this.getStepData()
          this.getQuizConfState()
          this.getQuizConfState2()
        })
      })
    },
    // 游戏配置项 弹窗返回
    setGamePopupBack() {
      this.isShowInterference = false
      this.componentId = ''
    },
    // 保存游戏配置项
    saveGameOptions() {
      // 调用子组件 保存方法
      this.$refs.ref_game.saveGameOptions()
    },
    // 游戏配置 子组件保存完成后 抛出事件
    finishSaveConfig() {
      this.isShowInterference = false
      this.componentId = ''
      // 刷新 step5 步骤所有游戏的配置状态
      this.getQuizConfState2()
    },
    // 保存step5 步骤 整个游戏配置
    saveGameConfiguration() {
      if (this.quizTypeObject[this.courseData.curriculumType].checkedArr.length === 0) {
        this.$message.error('请先勾选要使用的游戏')
        return false
      }
      // //0301,检查配置了游戏的选项是否全部勾选了是否游戏
      // console.log("======保存游戏前的数据：",this.quizTypeObject)
      // if(!this.checkIsAllSelectGame()){//如果返回false就表示没有全部勾选，则不保存
      //     return false
      // }
      // ////////////////
      console.log()
      const params = {
        curriculumId: this.courseData.teachingCurriculumId,
        curriculumType: this.courseData.curriculumType,
        quizType: this.quizTypeObject[this.courseData.curriculumType].checkedArr.toString()
      }
      saveQuiz(params).then(res => {
        this.$message.success('游戏保存成功')
      })
    },
    //0301,检查配置了游戏的选项是否全部勾选了是否游戏
    checkIsSelectGame(){
      console.log("======走到判断")
      if (this.quizTypeObject[this.courseData.curriculumType].checkedArr.length === 0) {
        this.$message.error('未勾选游戏配置,请先保存游戏配置！')
        return false
      }
        return true
    },
    ///////
    
    checkOneSentenceClick () {
      this.isShowCheckOneSentence = true
      // this.getConfData({type: '3001'})
      const params = {
        curriculumId: this.courseData.teachingCurriculumId,
        curriculumType: this.courseData.curriculumType,
        quizType: '3002'
      }
      getConfData(params).then(res => {
        this.checkOneSentenceForm.dataList = []

        for (const item of res) {
          this.checkOneSentenceForm.dataList.push({ url: 'http://172.18.132.130:10001/uploadFile/' + item.cardChartPath, sentenceList: item.items, sentence: '' })
        }
      })
    },
    saveCheckOneSentence () {
      const params = {
        curriculumId: this.courseData.teachingCurriculumId,
        curriculumType: this.courseData.curriculumType,
        quizType: this.currentQuizType,

        interfereNum: this.interferenceForm.interfereNum,
        items: this.interferenceForm.dataList
      }
      saveSentenceGroupConf(params).then(res => {
        this.$message.success('操作成功')
        this.isShowCheckOneSentence = false
      })
    }

  }
}
</script>
<style lang='scss'>
.stepPage {
  .quiz-container {
    .game-bar {
      display: inline-block;
      width: calc(50% - 20px);

      &:nth-child(odd) {
        margin-right: 40px;
      }

      margin-bottom: 20px;

      .tit {
        margin-bottom: 20px;color: #53402B;
      }

      .cont {
        border: 1px solid #EEEEEE;
        border-radius: 8px;
        padding: 20px;
        text-align: center;

        img {
          width: 78%;
          margin-bottom: 20px;
        }

        .bottom {
          background-color: #F7F6F4;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 9px 10px;
          .b-tip{
            font-size: 14px;
            color: #45433D;
            flex: 1;
            padding-left: 15px;
            text-align: left;
            svg{color:#FDC100;margin-right:4px;}
          }
        }
      }
    }
  }

  .step5Form {
    position: relative;

    .el-button {
      position: absolute;
      top: 20px;
      right: 20px;
    }
    .step5-button{
      right: 110px;
      top: 5px;
    }
  }
}
</style>
